import { WA_NUMBER, WA_MESSAGES, GUIDE_NAME } from '../constants'
import ContourMotif from './ContourMotif'

export default function WACTASection() {
  return (
    <section className="section bg-dark" style={{ position: 'relative', overflow: 'hidden' }}>
      {/* Subtle topographic underlay — barely-there map texture, not wallpaper */}
      <ContourMotif stroke="rgba(255,255,255,0.9)" opacity={0.05} />

      <div style={{ textAlign: 'center', color: 'white', maxWidth: '640px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <h2 className="section-title" style={{ color: 'white', textTransform: 'uppercase', letterSpacing: '1px' }}>
          Still have questions?
        </h2>
        <p className="section-sub" style={{ color: 'rgba(255,255,255,0.7)', margin: '0 auto 40px' }}>
          Trekking in Nepal requires careful planning. I am available 24/7 on WhatsApp to answer your questions about routes, gear, and availability. No obligation to book.
        </p>
        <a
          href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGES.general)}`}
          target="_blank" rel="noreferrer"
          className="btn btn-primary"
          style={{ padding: '16px 32px', fontSize: '15px' }}
        >
          Message {GUIDE_NAME} on WhatsApp
        </a>
      </div>
    </section>
  )
}
